






import {Component, Prop} from "vue-property-decorator";
import PrimaryPage from "../../layouts/primaryPage.vue";
import AskQuestion from "@/views/QA/askQuestion.vue";
import QATab from "@/views/QA/tabList.vue";
import QADetail from "@/views/QA/detail.vue";

@Component({
    name: 'index',
    components: {QADetail, QATab, AskQuestion, PrimaryPage}
})
export default class index extends PrimaryPage {
    @Prop({type: String, default: ''}) queryParams: string;
    defRoutes = [{
        path: 'QA',
        breadcrumbName: 'Q & A',
    }];

    keywords: string;

    //关键字搜索
    handleSearch(keywords: string = '') {
        this.keywords = keywords;
        this.showTabList();
    }

    //显示tab列表页
    showTabList() {
        this.$nextTick(() => {
            let qaAllModule: any = this.$refs.QATabList;
            qaAllModule.show(this.keywords);
        });
    }

    mounted() {
        try {
            let obj = JSON.parse(this.queryParams);
            if (obj) {
                this.keywords = obj.keywords;
            }
        } catch (e) {

        }
        this.showTabList();
    }

    //显示我的提问页面
    showAskQuestion() {
        this.switchRouting('askQuestion', {
            queryParams: JSON.stringify({
                skip: false
            })
        });
    }
}
